<carousel style="z-index: 0; margin:auto !important;"  [ngStyle]="{'width': (!IsMobile) ? '100%' : '70%'}" [height]="420" [cellWidth]="cellwidth"
    [arrowsOutside]="true">
    <div class="carousel-cell" *ngFor="let paragraphe of ParagrapheArrayS ">
        <app-service [Job]="paragraphe"></app-service>
    </div>
</carousel>
